/* import __COLOCATED_TEMPLATE__ from './sq-super-table-column-menu.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { superTableRemoveColumn, superTableAddColumn } from '@dashboard/shared-ui/events/sq-super-table/event-catalog';

// Adapted from Ember.Array.uniq
function uniq(array) {
  const ret = [];
  const seen = new Set();
  for (const item of array) {
    if (!seen.has(item)) {
      seen.add(item);
      ret.push(item);
    }
  }
  return ret;
}
let SqSuperTableColumnMenu = (_dec = computed('groupOptionsBy', 'options.length'), _class = class SqSuperTableColumnMenu extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "eventstream", _descriptor, this);
  }
  get optionGroups() {
    // If no "groupOptionsBy" header prop is specified
    // If there are no options, make sure to return a single empty group.
    if (!this.groupOptionsBy || this.options.length === 0) {
      return [{
        options: this.options
      }];
    }

    // Map options to groups by specified property
    const headers = uniq(this.options.map(option => option[this.groupOptionsBy]));

    // Reduce the subsequent "headers" array into an array of groups with
    // headers and options. Sort options with no header to the top of the
    // options list. The ones with headers are ordered by when the header
    // is first encountered in options.
    return headers.reduce((groups, header) => {
      return [...groups, {
        header,
        options: this.options.filter(option => option[this.groupOptionsBy] === header)
      }];
    }, []).sort((groupA, groupB) => {
      if (!groupA.header) {
        return -1;
      }
      if (!groupB.header) {
        return 1;
      }
      return 0;
    });
  }
  optionsDidChange(options, selectedOption) {
    if (this.multipleOptions) {
      const trackingEvent = options.includes(selectedOption) ? superTableAddColumn : superTableRemoveColumn;
      this.eventstream.track(trackingEvent(selectedOption));
    }
    this.action?.(options);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "optionGroups", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "optionGroups"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionsDidChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "optionsDidChange"), _class.prototype), _class);
export { SqSuperTableColumnMenu as default };